import GATSBY_COMPILED_MDX from "/opt/buildhome/repo/src/room/vietcoffee.mdx";
import * as React from "react";
import {Link, graphql} from "gatsby";
import {getImage} from "gatsby-plugin-image";
import Img from "../components/image";
const Room = ({data, children}) => {
  const image = getImage(data.mdx.frontmatter.image);
  return React.createElement("main", {
    className: "room"
  }, React.createElement(Img, {
    src: image,
    desc: data.mdx.frontmatter.image_alt
  }), React.createElement("div", {
    className: "words"
  }, React.createElement("h1", null, data.mdx.frontmatter.title), children, React.createElement(Link, {
    to: "/"
  }, "Go home")));
};
export const query = graphql`
  query ($id: String) {
    mdx(id: { eq: $id }) {
      frontmatter {
        title
        image_alt
        image {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`;
export const Head = () => React.createElement("title", null, "hi");
Room
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Room, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
